import { Typography } from "antd";

const { Text } = Typography;

/**
 * Renders an identifier with a click-to-copy affordance.
 *
 * Copies the raw value (no prefix), so pasting into BC or the Django admin
 * gives a clean lookup key. Clicks are contained here — call sites often sit
 * inside a clickable row or card, and copying must not also open that.
 *
 * Renders nothing when there is no value, so optional identifiers (a BC
 * Entry_No that hasn't synced yet) simply don't take up space.
 */
const CopyableId = ({ value, prefix = "", muted = false, label = "ID" }) => {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  const raw = String(value);

  return (
    <span
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
      style={{ display: "inline-flex", alignItems: "center" }}
    >
      <Text
        className="small"
        style={{
          fontVariantNumeric: "tabular-nums",
          whiteSpace: "nowrap",
          ...(muted ? { color: "#6c757d" } : { fontWeight: 600 }),
        }}
        copyable={{
          text: raw,
          tooltips: [`Copy ${label}`, `${label} copied`],
        }}
      >
        {prefix}
        {raw}
      </Text>
    </span>
  );
};

export default CopyableId;
